(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-25-rail"] && !Shopify.designMode) return;
  try {
    
class Lance25Rail extends HTMLElement {
  connectedCallback() {
    const show = (key) => {
      this.querySelectorAll('[data-l25-panel]').forEach((p) => { p.hidden = p.dataset.l25Panel !== key; });
      this.querySelectorAll('[data-l25-fam]').forEach((b) => b.classList.toggle('is-active', b.dataset.l25Fam === key));
    };
    this.querySelectorAll('[data-l25-fam]').forEach((b) => b.addEventListener('click', () => show(b.dataset.l25Fam)));
    this.querySelectorAll('[data-l25-jump]').forEach((b) => b.addEventListener('click', () => show(b.dataset.l25Jump)));
  }
}
customElements.define('lance-25-rail', Lance25Rail);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-audience"] && !Shopify.designMode) return;
  try {
    
class LanceAudience extends HTMLElement {
  connectedCallback() {
    this.PD = JSON.parse(this.querySelector('[data-aud-setdata]').textContent);
    // DC audDefs[aud].sets verbatim
    const SETS = {
      artists: {
        space: 'studio', color: '#FF3D9A', ink: '#FFFFFF',
        sets: [
          {name:'Artist Desk Set',why:'Layout, centered composition, and cut lines at the desk.',items:[['lance-french-curve',1],['straight-edge-with-slip-resistant-backing',1],['center-finding-rule',1]]},
          {name:'Large-Format Studio Set',why:'Long true lines and gripped edges for oversized work.',items:[['straight-edge-aluminum-rule',1],['straight-edge-with-slip-resistant-backing',1],['lance-hip-curve',1]]},
          {name:'Print & Book Arts Set',why:'Rulers for publication layout, centered folds and inking.',items:[['lance-agate-pica-ruler',1],['center-finding-rule',1],['straight-edge-with-slip-resistant-backing',1]]}
        ]},
      engineers: {
        space: 'lab', color: '#2038E8', ink: '#FFFFFF',
        sets: [
          {name:'Engineer Desk Set',why:'Inch + cm on one edge, fixed angles, and centers without arithmetic.',items:[['lance-straight-edge-e-metric-inch-centimeter',1],['template-triangle-ruler-30-60-90',1],['center-finding-rule',1]]},
          {name:'Technical Drawing Set',why:'The stainless edge, both drafting geometries, and the curve between them.',items:[['heavy-duty-drafting-stainless-steel-t-square',1],['template-triangle-ruler-30-60-90',1],['template-triangle-ruler-45-45-90',1],['lance-french-curve',1]]},
          {name:'Graduation & New-Hire Set',why:'A serious first instrument — desk-scale, durable, quietly symbolic.',items:[['lance-straight-edge-e-metric-inch-centimeter',1],['template-triangle-ruler-45-45-90',1]]}
        ]},
      makers: {
        space: 'shop', color: '#FF7A00', ink: '#131313',
        sets: [
          {name:'Cutting Table Set',why:'A gripped cutting edge, a heavy square to pull against, and one exact corner.',items:[['straight-edge-with-slip-resistant-backing',1],['heavy-duty-t-square',1],['aluminum-l-square',1]]},
          {name:'Pattern & Curve Set',why:'The patternmaking bench — long contours, tight transitions, cuffs, half-scale drafting.',items:[['lance-hip-curve',1],['lance-french-curve',1],['aluminum-cuff-rule',1],['lance-half-size-l-square',1]]},
          {name:'Long-Span Layout Set',why:'The long, true line plus direct centers for panels and spans.',items:[['straight-edge-aluminum-rule',1],['center-finding-rule',1]]}
        ]}
    };
    this.A = SETS[this.dataset.aud] || SETS.artists;
    this.mult = 1;
    this.render();
  }
  money(v) { return '$' + (v % 1 ? v.toFixed(2) : v.toFixed(0)); }
  render() {
    const A = this.A, m = this.mult;
    const chips = [{m:1,label:'One desk'},{m:4,label:`Shared ${A.space} ×4`},{m:12,label:'Whole program ×12'}];
    this.querySelector('[data-aud-scale]').innerHTML = chips.map((c) =>
      `<button data-mult="${c.m}" style="background:${m === c.m ? '#131313' : '#FFFFFF'};color:${m === c.m ? '#FBF8EF' : '#131313'};border:2px solid #131313;padding:9px 15px;font-family:'Archivo',sans-serif;font-weight:700;font-size:13.5px;cursor:pointer;">${c.label}</button>`).join(' ');
    this.querySelectorAll('[data-mult]').forEach((b) => b.addEventListener('click', () => { this.mult = Number(b.dataset.mult); this.render(); }));
    this.querySelector('[data-aud-scalenote]').textContent = m === 1 ? 'EVERY TOOL IS ALSO SOLD ON ITS OWN' : `QUANTITIES ×${m} — THE PRO DESK CONFIRMS VOLUME PRICING`;
    this.querySelector('[data-aud-sets]').innerHTML = A.sets.map((st) => {
      let tot = 0;
      const rows = st.items.map((it) => { const p = this.PD[it[0]]; if (!p) return '';
        tot += p.price * it[1] * m;
        return `<a href="${p.url}" style="display:flex;align-items:center;gap:10px;text-decoration:none;color:#131313;border:2px solid #E2DDCB;padding:7px 9px;background:#FBF8EF;">
          <img loading="lazy" decoding="async" src="${p.img}" alt="" style="width:46px;height:34px;object-fit:contain;flex:none;background:#FFFFFF;border:1px solid #E2DDCB;">
          <span style="flex:1;min-width:0;font-size:13px;font-weight:600;line-height:1.25;">${p.name}</span>
          <span style="font-family:'IBM Plex Mono',monospace;font-size:11px;color:#6B675C;flex:none;">×${it[1] * m} · ${this.money(p.price)}</span></a>`; }).join('');
      const est = this.money(Math.round(tot));
      return `<article style="background:#FFFFFF;border:3px solid #131313;display:flex;flex-direction:column;">
        <div style="padding:16px 16px 12px;border-bottom:3px solid #131313;background:${A.color};color:${A.ink};">
          <h3 style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:21px;line-height:1;margin:0;">${st.name}</h3>
          <p style="margin:6px 0 0;font-size:13px;line-height:1.45;">${st.why}</p>
        </div>
        <div style="padding:12px 14px;display:flex;flex-direction:column;gap:8px;flex:1;">${rows}</div>
        <div style="padding:12px 14px 14px;border-top:2px solid #131313;display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;">
          <span style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:19px;">${est}<span style="font-family:'IBM Plex Mono',monospace;font-size:9px;letter-spacing:.08em;color:#8F8B7E;font-weight:400;display:block;">ESTIMATED TOTAL</span></span>
          <button data-lance-inquiry data-inq-title="Team pricing" data-inq-ctx="${st.name}||Estimated ${est}" data-inq-note="Request tool sizes, quantities and a written quote." style="background:transparent;color:#131313;border:2px solid #131313;padding:9px 13px;font-family:'Archivo',sans-serif;font-weight:700;font-size:12.5px;cursor:pointer;">Team pricing</button>
        </div></article>`;
    }).join('');
  }
}
customElements.define('lance-audience', LanceAudience);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-collection"]) return;
  try {
    
document.querySelectorAll('[data-lance-collection]').forEach((root) => {
  const cards = Array.from(root.querySelectorAll('[data-shopping-card]'));
  const unit = root.querySelector('[data-shopping-unit]');
  const stock = root.querySelector('[data-shopping-stock]');
  root.querySelectorAll('[data-client-filter]').forEach((element) => { element.hidden = false; });
  Array.from(unit.options).forEach((option) => { if (option.value !== 'all' && !cards.some((card) => card.dataset.unit === option.value)) option.remove(); });
  const update = () => {
    cards.forEach((card) => { card.hidden = (unit.value !== 'all' && card.dataset.unit !== unit.value) || (stock.checked && card.dataset.available !== 'true'); });
    const count = cards.filter((card) => !card.hidden).length;
    root.querySelector('[data-shopping-count]').textContent = count ? 'Choose a tool to see its sizes' : 'Try another scale or availability filter';
    root.querySelector('[data-shopping-empty]').hidden = count > 0;
  };
  unit.addEventListener('change', update);
  stock.addEventListener('change', update);
  update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-header"]) return;
  try {
    
class LanceHeader extends HTMLElement {
  connectedCallback() {
    this.megas = this.querySelectorAll('[data-mega]');
    this.querySelectorAll('[data-mega-toggle]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const panel = this.querySelector(`[data-mega="${btn.dataset.megaToggle}"]`);
        const open = panel.hidden;
        this.closeAll();
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
      });
    });
    const navBtn = this.querySelector('[data-nav-toggle]');
    const drawer = this.querySelector('[data-nav-drawer]');
    navBtn.addEventListener('click', () => {
      drawer.hidden = !drawer.hidden;
      navBtn.textContent = drawer.hidden ? 'Menu' : 'Close';
      navBtn.setAttribute('aria-expanded', String(!drawer.hidden));
    });
    document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.closeAll(); });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const openTrigger = this.querySelector('[aria-expanded="true"]');
      this.closeAll();
      if (openTrigger) openTrigger.focus();
    });
    const cartBtn = this.querySelector('[data-cart-open]');
    cartBtn.addEventListener('click', () => {
      const d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') d.open(); else window.location.href = window.routes.cart_url;
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        fetch(`${cartUrl}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        })
          .then((response) => response.ok ? response.json() : Promise.reject())
          .then((cart) => {
            this.querySelectorAll('[data-cart-count]').forEach((count) => {
              count.textContent = String(Number(cart.item_count) || 0);
            });
          })
          .catch(() => {});
      });
    }
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }
  closeAll() {
    this.megas.forEach((m) => { m.hidden = true; });
    this.querySelectorAll('[data-mega-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    const drawer = this.querySelector('[data-nav-drawer]');
    const navBtn = this.querySelector('[data-nav-toggle]');
    if (drawer) drawer.hidden = true;
    if (navBtn) {
      navBtn.textContent = 'Menu';
      navBtn.setAttribute('aria-expanded', 'false');
    }
  }
}
customElements.define('lance-header', LanceHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-lab"] && !Shopify.designMode) return;
  try {
    
class LanceLab extends HTMLElement {
  connectedCallback() {
    this.P = JSON.parse(this.querySelector('[data-lab-products]').textContent);
    this.st = { u: null, e: null, d: null, L: 0 };
    if (new URLSearchParams(location.search).get('from') === 'finder') {
      const banner = this.querySelector('[data-lab-from]');
      banner.hidden = false;
      this.querySelector('[data-lab-from-clear]').addEventListener('click', () => { banner.hidden = true; });
    }
    this.querySelectorAll('[data-lab-unit]').forEach((b) => b.addEventListener('click', () => {
      this.st.u = b.dataset.labUnit;
      if (this.st.u === 'both') { this.st.e = null; this.st.d = null; }
      this.st.L = 0; this.render();
    }));
    this.querySelectorAll('[data-lab-edge]').forEach((b) => b.addEventListener('click', () => { if (this.st.u === 'both') return; this.st.e = b.dataset.labEdge; this.st.L = 0; this.render(); }));
    this.querySelectorAll('[data-lab-dir]').forEach((b) => b.addEventListener('click', () => { if (this.st.u === 'both') return; this.st.d = b.dataset.labDir; this.st.L = 0; this.render(); }));
    this.querySelectorAll('[data-lab-edit]').forEach((b) => b.addEventListener('click', () => {
      const n = b.dataset.labEdit;
      if (n === '1') this.st.u = null; if (n === '2') this.st.e = null; if (n === '3') this.st.d = null;
      this.render();
    }));
    // expert matrix
    const mx = this.querySelector('[data-lab-matrix]');
    const combos = [];
    [['english','INCH'],['metric','CM']].forEach((u) => [['top','TOP'],['bottom','BOT']].forEach((e) => [['lr','L→R'],['rl','R→L']].forEach((d) => combos.push({ u: u[0], e: e[0], d: d[0], label: u[1] + ' · ' + e[1] + ' · ' + d[1] }))));
    combos.push({ u: 'both', e: null, d: null, label: 'INCH + CM · COMBINED' });
    mx.innerHTML = combos.map((c, i) => `<button class="llab__mx" data-mx="${i}">${c.label}</button>`).join('');
    mx.querySelectorAll('[data-mx]').forEach((b) => b.addEventListener('click', () => {
      const c = combos[Number(b.dataset.mx)];
      this.st = { u: c.u, e: c.e, d: c.d, L: 0 }; this.render();
    }));
    this.combos = combos;
    this.querySelector('[data-lab-flip]').addEventListener('click', () => { this.st.d = this.st.d === 'lr' ? 'rl' : 'lr'; this.render(); });
    this.querySelector('[data-lab-reset]').addEventListener('click', () => { this.st = { u: null, e: null, d: null, L: 0 }; this.render(); });
    this.render();
  }
  handle() {
    const s = this.st;
    if (s.u === 'both') return 'black-anodized-e-metric-ruler-inch-centimeter';
    if (!s.u || !s.e || !s.d) return null;
    const prefix = s.u === 'metric' ? 'black-metric' : 'black-anodized';
    return `${prefix}-${s.d === 'lr' ? 'left-right' : 'right-left'}-${s.e}-edge-rule`;
  }
  render() {
    const s = this.st, q = (x) => this.querySelector(x);
    const both = s.u === 'both';
    const effU = s.u || 'english', effE = s.e || 'top', effD = s.d || 'lr';
    const done = !!s.u && (both || (!!s.e && !!s.d));
    this.querySelectorAll('[data-lab-unit]').forEach((b) => b.classList.toggle('is-sel', b.dataset.labUnit === s.u));
    // bench
    const nums = effU === 'metric' ? ['0','5','10','15','20','25','30'] : ['0','2','4','6','8','10','12'];
    const seq = effD === 'rl' ? nums.slice().reverse() : nums;
    q('[data-lab-topnums]').innerHTML = seq.map((n) => `<span>${n}</span>`).join('');
    q('[data-lab-botnums]').innerHTML = seq.map((n) => `<span>${n}</span>`).join('');
    q('[data-lab-topnums]').style.opacity = both || effE === 'top' ? 1 : 0.25;
    q('[data-lab-botnums]').style.opacity = both || effE === 'bottom' ? 1 : 0.25;
    q('[data-lab-topbar]').style.background = s.e === 'top' || both ? '#00E5FF' : '#3A3A3A';
    q('[data-lab-botbar]').style.background = s.e === 'bottom' ? '#FFB300' : '#3A3A3A';
    q('[data-lab-zero]').style.left = both ? '45%' : (effD === 'lr' ? '4%' : 'calc(96% - 18px)');
    const at = q('[data-lab-arrowtxt]');
    if (both) { at.textContent = '⇄ READS FROM EITHER SIDE'; at.style.color = '#00E5A0'; }
    else if (s.d) { at.textContent = s.d === 'lr' ? '⟶ NUMBERS CLIMB LEFT TO RIGHT' : '⟵ NUMBERS CLIMB RIGHT TO LEFT'; at.style.color = s.d === 'lr' ? '#00805A' : '#C4147A'; }
    else { at.textContent = 'SET THE EDGE AND DIRECTION'; at.style.color = '#9A968A'; }
    q('[data-lab-orienttxt]').textContent = done ? (both ? 'INCH + CM · EITHER SIDE' : `${effU === 'metric' ? 'CM' : 'INCH'} · ${effE.toUpperCase()} EDGE · ${effD === 'lr' ? 'L→R' : 'R→L'}`) : '';
    // question cards
    const uLabels = { english: 'Inch — eighths and sixteenths', metric: 'Metric — centimeters and millimeters', both: 'Inch + cm — combined, reads from either side' };
    q('[data-lab-a1]').textContent = s.u ? uLabels[s.u] : 'Pick inch, cm, or the combined rule above.';
    q('[data-lab-a1]').style.color = s.u ? '#00804A' : '#6B675C';
    q('[data-lab-edit="1"]').hidden = !s.u;
    const q2 = q('[data-lab-q2]'), q3 = q('[data-lab-q3]');
    q2.style.opacity = s.u && !both ? 1 : 0.5;
    q2.style.borderColor = s.e ? '#131313' : (s.u && !both ? '#131313' : '#D9D4C2');
    q('[data-lab-a2]').textContent = both ? 'Not needed — reads from either side.' : (s.e ? (s.e === 'top' ? 'Top edge — the far edge, against the work.' : 'Bottom edge — the near edge, against the work.') : '—');
    q('[data-lab-a2]').style.color = s.e || both ? '#00804A' : '#6B675C';
    q('[data-lab-edit="2"]').hidden = !s.e;
    q('[data-lab-q2opts]').hidden = !(s.u && !both && !s.e);
    q3.style.opacity = s.e && !both ? 1 : 0.5;
    q3.style.borderColor = s.d ? '#131313' : (s.e && !both ? '#131313' : '#D9D4C2');
    q('[data-lab-a3]').textContent = both ? 'Not needed — reads from either side.' : (s.d ? (s.d === 'lr' ? 'Left to right — zero at your left hand.' : 'Right to left — zero at your right hand.') : '—');
    q('[data-lab-a3]').style.color = s.d || both ? '#00804A' : '#6B675C';
    q('[data-lab-edit="3"]').hidden = !s.d;
    q('[data-lab-q3opts]').hidden = !(s.u && !both && s.e && !s.d);
    q('[data-lab-bothnote]').hidden = !both;
    // matrix selection state
    this.querySelectorAll('[data-mx]').forEach((b, i) => {
      const c = this.combos[i];
      b.classList.toggle('is-sel', done && c.u === s.u && c.e === s.e && c.d === s.d);
    });
    // result
    const res = q('[data-lab-result]');
    const h = done ? this.handle() : null;
    const p = h ? this.P[h] : null;
    res.hidden = !p;
    if (!p) return;
    let vi = Math.min(this.st.L, p.variants.length - 1);
    const v = p.variants[vi] || {};
    q('[data-lab-resimg]').src = p.img; q('[data-lab-resimg]').alt = p.name;
    q('[data-lab-resname]').textContent = p.name;
    q('[data-lab-why]').textContent = both
      ? 'One rule, both systems, engraved to read correctly from either side of the bench — edge and direction never matter.'
      : `Standing at the bench edge, this rule reads ${effD === 'lr' ? 'left to right' : 'right to left'} along the ${effE} working edge — so the numbers are upright and climbing away from your zero, exactly as you look down at the work.`;
    const chips = [];
    const uColors = { english: '#00C2FF', metric: '#FFD500', both: '#00E5A0' };
    chips.push([both ? 'INCH + CM' : (effU === 'metric' ? 'METRIC (CM)' : 'INCH'), uColors[effU] || '#00E5A0']);
    if (!both) { chips.push([effE === 'top' ? 'TOP EDGE' : 'BOTTOM EDGE', effE === 'top' ? '#00E5FF' : '#FFB300']);
      chips.push([effD === 'lr' ? 'READS L → R' : 'READS R → L', effD === 'lr' ? '#00E5A0' : '#FF3D9A']); }
    chips.push(['FROM YOUR POSITION', '#F2EFE4']);
    q('[data-lab-chips]').innerHTML = chips.map((c) => `<span style="border:2px solid ${c[1]};color:${c[1]};font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:.1em;padding:4px 9px;">${c[0]}</span>`).join('');
    q('[data-lab-vcount]').textContent = p.variants.length + ' LENGTHS';
    const lensEl = q('[data-lab-lens]');
    lensEl.innerHTML = p.variants.map((vv, i) => `<button data-ll="${i}" style="background:${i === vi ? '#FFD500' : 'transparent'};color:${i === vi ? '#131313' : (vv.available ? '#F2EFE4' : '#77736A')};border:2px solid ${i === vi ? '#FFD500' : '#3A3A3A'};padding:8px 12px;font-family:'IBM Plex Mono',monospace;font-size:12px;cursor:pointer;">${vv.title}</button>`).join('');
    lensEl.querySelectorAll('[data-ll]').forEach((b) => b.addEventListener('click', () => { this.st.L = Number(b.dataset.ll); this.render(); }));
    q('[data-lab-sku]').textContent = v.sku || '';
    const av = q('[data-lab-avail]');
    av.textContent = v.available ? 'AVAILABLE' : 'CURRENTLY UNAVAILABLE';
    av.style.color = v.available ? '#00E5A0' : '#FF8A5C';
    q('[data-lab-price]').textContent = v.price || '';
    q('[data-lab-view]').href = `${p.url}?variant=${v.id}`;
    q('[data-lab-flip]').hidden = both;
    const add = q('[data-lab-add]');
    add.textContent = v.available ? `Add to cart — ${v.price}` : 'Request this configuration';
    add.onclick = async () => {
      if (!v.available) return;
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1 }) });
      window.location.href = '/cart';
    };
  }
}
customElements.define('lance-lab', LanceLab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-norules-product"]) return;
  try {
    
class LanceNoRulesProduct extends HTMLElement {
  connectedCallback() {
    const variants = JSON.parse(this.querySelector('[data-nrp-variants]').textContent);
    const inquiry = this.querySelector('[data-nrp-inquiry]');
    this.querySelectorAll('[data-nrp-variant-id]').forEach((button) => button.addEventListener('click', () => {
      const variant = variants.find((item) => item.id === Number(button.dataset.nrpVariantId));
      if (!variant) return;
      this.querySelectorAll('[data-nrp-variant-id]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-checked', String(active));
      });
      this.querySelector('[data-nrp-price]').textContent = variant.price;
      this.querySelector('[data-nrp-variant]').textContent = variant.title;
      const sku = this.querySelector('[data-nrp-sku]');
      if (sku) sku.textContent = variant.sku || '';
      inquiry.dataset.inqCtx = `${document.querySelector('h1').textContent}||${variant.title} · ${variant.price}`;
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }));
    this.querySelectorAll('[data-nrp-thumb]').forEach((button) => button.addEventListener('click', () => {
      const image = this.querySelector('[data-nrp-main-image]');
      image.src = button.dataset.nrpThumb;
      image.srcset = button.dataset.nrpThumbSrcset || '';
      this.querySelectorAll('[data-nrp-thumb]').forEach((item) => item.classList.toggle('is-active', item === button));
    }));
  }
}
customElements.define('lance-norules-product', LanceNoRulesProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-pdp"]) return;
  try {
    
class LancePdp extends HTMLElement {
  connectedCallback() {
    this.style.setProperty('--accent', this.dataset.accent);
    this.style.setProperty('--accent-ink', this.dataset.accentInk);
    const variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    const maxMM = Math.max(...variants.map((v) => v.mm || 0), 1);
    const q = (s) => this.querySelector(s);
    const setText = (s, t) => { const el = q(s); if (el) el.textContent = t; };
    const bar = q('[data-atc-bar]');
    const photoCaption = q('[data-photo-caption]');
    const defaultPhotoCaption = photoCaption ? photoCaption.textContent : '';
    const defaultPhotoAlt = q('[data-main-image]') ? q('[data-main-image]').alt : '';
    const select = (id) => {
      const v = variants.find((x) => x.id === id);
      if (!v) return;
      this.querySelectorAll('[data-variant]').forEach((b) => {
        const sel = Number(b.dataset.variant) === id;
        b.classList.toggle('is-sel', sel);
        b.setAttribute('aria-checked', String(sel));
      });
      setText('[data-price]', v.price); setText('[data-price-btn]', v.price); setText('[data-price-bar]', v.price);
      setText('[data-varlabel]', v.title); setText('[data-varlabel-bar]', v.title); setText('[data-sku]', v.sku || '');
      setText('[data-black-proof-label]', v.sku === 'TBLR-20EM-LAN' ? 'These photographs show your selected 20-inch ruler, SKU TBLR-20EM-LAN.' : 'Photo: 20-inch ruler. Selected size: ' + v.title + '.');
      setText('[data-shipping-quick]', v.shippingShort || 'Confirm shipping before ordering.');
      setText('[data-shipping-size]', v.shippingSummary || 'Estimate your selected items and destination in the cart.');
      setText('[data-dimension-size]', v.title === 'Default Title' ? 'One size' : v.title);
      const dimensionConflict = v.id === 52950768419134 || v.id === 52950768517438;
      setText('[data-dimension-size-label]', dimensionConflict ? 'Catalog option label' : 'Size');
      setText('[data-dimension-length]', dimensionConflict ? 'Confirm dimensions before ordering' : v.mm > 0 ? v.mm + ' mm' : '');
      const lengthRow = q('[data-dimension-length-row]');
      if (lengthRow) lengthRow.hidden = !dimensionConflict && !(v.mm > 0);
      const dimensionNote = q('[data-dimension-conflict]');
      if(dimensionNote) {dimensionNote.hidden = !dimensionConflict;dimensionNote.textContent = v.id === 52950768419134 ? 'LS-012-LAN: Contact Lance to confirm the short-arm measurement before ordering for an exact fit.' : v.id === 52950768517438 ? 'LS-615M-LAN: Contact Lance to confirm both arm measurements before ordering for an exact fit.' : '';}
      setText('[data-dimension-width-label]', v.bladeWidthMM ? 'Blade width' : 'Width');
      setText('[data-dimension-width]', (v.bladeWidthMM || v.widthMM) ? (v.bladeWidthMM || v.widthMM) + ' mm' : '');
      const widthRow = q('[data-dimension-width-row]');
      if (widthRow) widthRow.hidden = !(v.bladeWidthMM || v.widthMM);
      setText('[data-dimension-head]', v.headLengthMM ? v.headLengthMM + ' mm' : '');
      const headRow = this.querySelector('[data-dimension-head-row]');
      if (headRow) headRow.hidden = !v.headLengthMM;
      setText('[data-dimension-thickness]', v.thicknessMM ? v.thicknessMM + ' mm' : '');
      const thicknessRow = q('[data-dimension-thickness-row]');
      if (thicknessRow) thicknessRow.hidden = !v.thicknessMM;
      const specInquiry = q('[data-spec-inquiry]');
      if (specInquiry) specInquiry.href = 'mailto:info@lanceruler.com?subject=' + encodeURIComponent('Specification request — ' + v.title + ' — ' + (v.sku || v.id));
      const avail = q('[data-avail]');
      if (avail) { avail.textContent = v.available ? 'Available' : 'Currently unavailable'; avail.style.color = v.available ? '#00804A' : '#B33500'; }
      const idInput = q('[data-form-variant]'); if (idInput) idInput.value = v.id;
      const atc = q('[data-atc]');
      if (atc) {
        atc.disabled = !v.available;
        atc.setAttribute('aria-disabled', String(!v.available));
        const atcLabel = q('[data-atc-label]');
        if (atcLabel) atcLabel.innerHTML = v.available ? `Add to cart — <span data-price-btn>${v.price}</span>` : 'Unavailable — request this size';
      }
      if (bar) {
        bar.disabled = !v.available;
        bar.setAttribute('aria-disabled', String(!v.available));
        bar.textContent = v.available ? 'Add to cart' : 'Unavailable';
      }
      const sil = q('[data-sil]');
      if (sil && v.mm) { sil.style.width = Math.max(16, Math.round((v.mm / maxMM) * 100)) + '%'; setText('[data-sil-txt]', v.title.toUpperCase()); }
      try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); } catch (e) {}
      this.dispatchEvent(new CustomEvent('lance:variant-changed', { bubbles: true, detail: { variant: v } }));
    };
    this.querySelectorAll('[data-variant]').forEach((b) => b.addEventListener('click', () => select(Number(b.dataset.variant))));
    this.querySelectorAll('[data-thumb]').forEach((t) => t.addEventListener('click', () => {
      const mainImage = q('[data-main-image]');
      mainImage.srcset = t.dataset.thumbSrcset || '';
      mainImage.src = t.dataset.thumb;
      mainImage.alt = t.dataset.photoLabel || defaultPhotoAlt;
      if (photoCaption) photoCaption.textContent = t.dataset.photoLabel || defaultPhotoCaption;
      if (q('[data-photo-zoom]')) q('[data-photo-zoom]').href = t.dataset.thumb;
      this.querySelectorAll('[data-thumb]').forEach((x) => x.classList.toggle('is-sel', x === t));
    }));
    if (bar) bar.addEventListener('click', () => {
      const submitButton = q('[data-atc]');
      if (!submitButton || submitButton.disabled || bar.disabled) return;
      submitButton.click();
    });
    const mobileBar = q('.lpdp__mobbar');
    const buyCard = q('[data-buy-card]');
    if (mobileBar && buyCard) {
      const mobileQuery = window.matchMedia('(max-width: 820px)');
      const syncMobileBar = () => {
        const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        const primary = q('[data-atc]');
        const primaryRect = primary && primary.getBoundingClientRect();
        const primaryVisible = primaryRect && primaryRect.top >= 0 && primaryRect.bottom <= viewportHeight;
        const barTop = viewportHeight - mobileBar.offsetHeight;
        const overlapsControl = Array.from(buyCard.querySelectorAll('[data-variant],.lpdp__quantity,[data-tier-math],[data-shipping-notice]')).some((control) => {
          const rect = control.getBoundingClientRect();
          return rect.height > 0 && rect.top < viewportHeight && rect.bottom > barTop;
        });
        const dialogVisible = Array.from(document.querySelectorAll('[role="dialog"][aria-modal="true"],#shopify-pc__banner,.shopify-pc__banner,[data-nav-drawer]:not([hidden])')).some((dialog) => {
          const rect = dialog.getBoundingClientRect();
          return rect.height > 0 && rect.width > 0 && rect.top < viewportHeight && rect.bottom > 0 && getComputedStyle(dialog).visibility !== 'hidden';
        });
        const editingQuantity = document.activeElement === q('[data-tier-quantity]');
        const visible = mobileQuery.matches && !primaryVisible && !overlapsControl && !dialogVisible && !editingQuantity;
        mobileBar.classList.toggle('is-visible', visible);
        mobileBar.setAttribute('aria-hidden', String(!visible));
        mobileBar.inert = !visible;
      };
      window.addEventListener('scroll', syncMobileBar, { passive: true });
      window.addEventListener('resize', syncMobileBar, { passive: true });
      if (window.visualViewport) window.visualViewport.addEventListener('resize', syncMobileBar, { passive: true });
      document.addEventListener('click', () => requestAnimationFrame(syncMobileBar));
      this.addEventListener('focusin', syncMobileBar);
      this.addEventListener('focusout', () => requestAnimationFrame(syncMobileBar));
      document.addEventListener('visitorConsentCollected', syncMobileBar);
      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', syncMobileBar);
      syncMobileBar();
    }
  }
}
customElements.define('lance-pdp', LancePdp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-pref"] && !Shopify.designMode) return;
  try {
    
class LancePref extends HTMLElement {
  connectedCallback() {
    const KEY = 'lance-aud-pref';
    const off = this.querySelector('[data-pref-off]');
    const apply = (id) => {
      off.hidden = !!id;
      this.querySelectorAll('[data-pref-panel]').forEach((p) => { p.hidden = p.dataset.prefPanel !== id; });
    };
    this.querySelectorAll('[data-pref-pick]').forEach((b) => b.addEventListener('click', () => {
      try { localStorage.setItem(KEY, b.dataset.prefPick); } catch (e) {}
      apply(b.dataset.prefPick);
    }));
    this.querySelectorAll('[data-pref-clear]').forEach((b) => b.addEventListener('click', () => {
      try { localStorage.removeItem(KEY); } catch (e) {}
      apply(null);
    }));
    let saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    if (saved && this.querySelector(`[data-pref-panel="${saved}"]`)) apply(saved);
  }
}
customElements.define('lance-pref', LancePref);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-retail"] && !Shopify.designMode) return;
  try {
    
class LanceRetail extends HTMLElement {
  connectedCallback() {
    // DC program-builder logic, verbatim
    this.DEFS = {
      rbStore: [{id:'art',l:'Art & drafting supply'},{id:'fabric',l:'Fabric & sewing'},{id:'hardware',l:'Hardware & shop'},{id:'campus',l:'Campus & bookstore'},{id:'gift',l:'Gift & museum'}],
      rbSpace: [{id:'counter',l:'Counter or endcap',s:'UNDER 2 FT'},{id:'bay',l:'A fixture bay',s:'2–4 FT'},{id:'wall',l:'A full wall panel',s:'4 FT+'}],
      rbAud: [{id:'teachers',l:'Teachers & students'},{id:'artists',l:'Artists & designers'},{id:'engineers',l:'Engineers & drafters'},{id:'makers',l:'Makers & sewists'},{id:'mixed',l:'A general mix'}],
      rbTerm: [{id:'perm',l:'Permanent program'},{id:'season',l:'Seasonal test'}]
    };
    this.st = { rbStore: null, rbSpace: null, rbAud: null, rbTerm: null };
    this.render();
  }
  render() {
    Object.keys(this.DEFS).forEach((key) => {
      const wrap = this.querySelector(`[data-rb="${key}"]`);
      wrap.innerHTML = this.DEFS[key].map((o) =>
        `<button class="lr9__rbopt${this.st[key] === o.id ? ' is-sel' : ''}" data-pick="${key}:${o.id}">${o.l}${o.s ? `<span style="display:block;font-family:'IBM Plex Mono',monospace;font-weight:400;font-size:9px;letter-spacing:.1em;opacity:.7;margin-top:2px;">${o.s}</span>` : ''}</button>`).join('');
      wrap.querySelectorAll('[data-pick]').forEach((b) => b.addEventListener('click', () => {
        const [k, id] = b.dataset.pick.split(':'); this.st[k] = id; this.render();
      }));
    });
    const s = this.st;
    const res = this.querySelector('[data-rb-result]');
    const done = s.rbStore && s.rbSpace && s.rbAud && s.rbTerm;
    if (!done) {
      res.innerHTML = `<div style="border:3px dashed #B7B2A0;background:#F6F2E7;padding:18px 20px;font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:.1em;color:#8F8B7E;">ANSWER ALL FOUR — THE RECOMMENDED PROGRAM ASSEMBLES HERE.</div>`;
      return;
    }
    const capsuleNames = {teachers:'Teachers Rule — Back to School',artists:'Artists Rule — Studio Tools',engineers:'Engineers Rule — Graduation',makers:'Makers Rule — Cutting & Layout',mixed:'Designers Rule — Anniversary'};
    let prog, why, fixture, orderClass, accent;
    if (s.rbTerm === 'season' || s.rbSpace === 'counter') {
      prog = 'X RULE CAPSULE · ' + capsuleNames[s.rbAud]; accent = '#FF3D9A';
      why = 'A focused message in the space you have — one audience, one occasion, refreshed each season without touching core shelving.';
      fixture = 'Counter display or endcap header — capsule signage, 5–8 instruments'; orderClass = 'ENTRY — SMALLEST OPENING ORDER';
    } else if (s.rbSpace === 'wall') {
      prog = 'THE LANCE 25'; accent = '#FFD500';
      why = 'Your space earns the full destination: a curated 25-instrument program selected from the seven-family catalog, the website’s Tool Wall translated to the floor.';
      fixture = 'Full wall panel — seven color-blocked bays, spectrum band, in-aisle Finder QR'; orderClass = 'FULL PROGRAM — PLANOGRAM + REPLENISHMENT LOGIC';
    } else {
      prog = 'LANCE 7'; accent = '#FFC400';
      why = 'One proposed instrument from each family — the whole selection logic in a fixture bay, and the cleanest way to prove the category before the full wall.';
      fixture = 'Fixture bay — seven hooks, seven color chips, header card'; orderClass = 'MID — ONE FACING PER FAMILY + BACKSTOCK';
    }
    const covMap = {teachers:['STRAIGHT EDGES','TRIANGLES','T-SQUARES'],artists:['CURVES','CENTER-FINDING','STRAIGHT EDGES'],engineers:['T-SQUARES','TRIANGLES','BLACK ENGRAVED'],makers:['CORK-BACKED','L-SQUARES','BLACK ENGRAVED'],mixed:['ALL SEVEN FAMILIES']};
    const lbl = (key, id) => (this.DEFS[key].find((x) => x.id === id) || {}).l || '';
    const sel = [lbl('rbStore', s.rbStore), lbl('rbSpace', s.rbSpace), lbl('rbAud', s.rbAud), lbl('rbTerm', s.rbTerm)].join(' · ');
    res.innerHTML = `<div style="border:3px solid #131313;background:#131313;color:#F2EFE4;box-shadow:8px 9px 0 ${accent};padding:24px;">
      <div style="font-family:'IBM Plex Mono',monospace;font-size:10px;letter-spacing:.16em;color:#9A968A;">YOUR STORE — ${sel}</div>
      <h3 style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:clamp(26px,3.4vw,44px);line-height:1;margin:10px 0 8px;color:${accent};">${prog}</h3>
      <p style="margin:0 0 14px;font-size:15px;line-height:1.6;max-width:64ch;color:#C9C5B8;">${why}</p>
      <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(min(240px,100%),1fr));gap:10px;margin:0 0 16px;">
        <div style="border:2px solid #3A3A3A;padding:11px 13px;"><div style="font-family:'IBM Plex Mono',monospace;font-size:9px;letter-spacing:.14em;color:#9A968A;">FIXTURE</div><div style="font-size:13.5px;line-height:1.45;margin-top:4px;">${fixture}</div></div>
        <div style="border:2px solid #3A3A3A;padding:11px 13px;"><div style="font-family:'IBM Plex Mono',monospace;font-size:9px;letter-spacing:.14em;color:#9A968A;">OPENING-ORDER CLASS</div><div style="font-size:13.5px;line-height:1.45;margin-top:4px;">${orderClass}</div></div>
        <div style="border:2px solid #3A3A3A;padding:11px 13px;"><div style="font-family:'IBM Plex Mono',monospace;font-size:9px;letter-spacing:.14em;color:#9A968A;">FAMILY EMPHASIS</div><div style="display:flex;flex-wrap:wrap;gap:5px;margin-top:6px;">${(covMap[s.rbAud] || []).map((t) => `<span style="background:${accent};color:#131313;font-family:'IBM Plex Mono',monospace;font-size:9px;letter-spacing:.08em;padding:3px 7px;">${t}</span>`).join('')}</div></div>
      </div>
      <div style="display:flex;flex-wrap:wrap;gap:10px;">
        <button data-lance-inquiry data-inq-title="Program proposal — ${prog}" data-inq-ctx="${sel}||${fixture}||${orderClass}" data-inq-note="The retail desk turns this into a formal proposal — opening-order economics, display credits and fixture options, modeled account by account." style="background:${accent};color:#131313;border:3px solid ${accent};padding:13px 22px;font-family:'Archivo',sans-serif;font-weight:700;font-size:15px;cursor:pointer;">Request this proposal</button>
        <button data-rb-reset style="background:transparent;color:#9A968A;border:3px solid transparent;padding:13px 6px;font-family:'Archivo',sans-serif;font-weight:700;font-size:14px;cursor:pointer;text-decoration:underline;">Start over</button>
      </div></div>`;
    res.querySelector('[data-rb-reset]').addEventListener('click', () => { this.st = { rbStore: null, rbSpace: null, rbAud: null, rbTerm: null }; this.render(); });
  }
}
customElements.define('lance-retail', LanceRetail);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-teachers"] && !Shopify.designMode) return;
  try {
    
class LanceTeachers extends HTMLElement {
  connectedCallback() {
    // subject tabs
    this.querySelectorAll('[data-subj]').forEach((b) => b.addEventListener('click', () => {
      this.querySelectorAll('[data-subj]').forEach((x) => x.classList.toggle('is-active', x === b));
      this.querySelectorAll('[data-subj-panel]').forEach((p) => { p.hidden = p.dataset.subjPanel !== b.dataset.subj; });
    }));
    // classroom sets — DC classroomSets() verbatim
    this.PD = JSON.parse(this.querySelector('[data-set-data]').textContent);
    this.SETS = [
      {key:'straightedge',name:'Classroom Straightedge Set',color:'#2038E8',ink:'#FFFFFF',
       desc:'One true edge per student, plus an instructor rule for the board. The baseline every drawing program starts from.',
       perStudent:[['straight-edge-aluminum-rule',1]],shared:[['heavy-duty-t-square',1]]},
      {key:'geometry',name:'Geometry & Drafting Set',color:'#6E30F2',ink:'#FFFFFF',
       desc:'The two triangles geometry is built on, a square to pull against, and a straight edge — per desk.',
       perStudent:[['template-triangle-ruler-30-60-90',1],['template-triangle-ruler-45-45-90',1],['standard-t-square',1]],shared:[['heavy-duty-drafting-stainless-steel-t-square',1]]},
      {key:'artroom',name:'Art Room Set',color:'#FF3D9A',ink:'#FFFFFF',
       desc:'Curves, centers, and edges for the room where marks matter more than millimeters.',
       perStudent:[['lance-french-curve',1],['center-finding-rule',1],['straight-edge-aluminum-rule',1]],shared:[['lance-agate-pica-ruler',2]]},
      {key:'fashion',name:'Fashion & Patternmaking Set',color:'#FF7A5C',ink:'#131313',
       desc:'Hip and French curves, a calibrated corner, and a cuff rule — the patternmaking bench, per student.',
       perStudent:[['lance-hip-curve',1],['lance-french-curve',1],['aluminum-l-square',1],['aluminum-cuff-rule',1]],shared:[]},
      {key:'demo',name:'Instructor Demonstration Set',color:'#131313',ink:'#F2EFE4',fixed:true,
       desc:'Tools for drawing-board and classroom demonstrations.',
       perStudent:[],sharedList:[['heavy-duty-t-square',1],['aluminum-l-square',1],['straight-edge-aluminum-rule',1],['lance-hip-curve',1]]}
    ];
    this.setKey = 'geometry'; this.classSize = 24;
    this.renderSets();
  }
  money(v) { return '$' + (v % 1 ? v.toFixed(2) : v.toFixed(0)); }
  renderSets() {
    const cur = this.SETS.find((s) => s.key === this.setKey) || this.SETS[0];
    const tabs = this.querySelector('[data-set-tabs]');
    tabs.innerHTML = this.SETS.map((s) => `<button class="lt__settab" data-settab="${s.key}" style="${s.key === this.setKey ? `background:${s.color};color:${s.ink};` : ''}">${s.name}</button>`).join('');
    tabs.querySelectorAll('[data-settab]').forEach((b) => b.addEventListener('click', () => { this.setKey = b.dataset.settab; this.renderSets(); }));
    const N = this.classSize;
    const comps = []; let est = 0, units = 0;
    const push = (h, qty, per) => { const p = this.PD[h]; if (!p) return; est += p.price * qty; units += qty;
      comps.push({ name: p.name, img: p.img, ea: this.money(p.price), qty, per, url: p.url, warn: !p.available }); };
    (cur.perStudent || []).forEach((it) => push(it[0], it[1] * N, 'per student'));
    (cur.shared || []).forEach((it) => push(it[0], it[1], 'instructor'));
    (cur.sharedList || []).forEach((it) => push(it[0], it[1], 'demonstration'));
    const sizeLabel = cur.fixed ? 'One demonstration set' : `${N} students · ${units} tools`;
    const estTxt = this.money(Math.round(est));
    const sizeChips = cur.fixed ? '' : `<div style="font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:.16em;margin-bottom:9px;">CLASS SIZE</div>
      <div style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:16px;">${[12,18,24,30].map((z) =>
        `<button data-size="${z}" style="background:${z === N ? '#131313' : '#FBF8EF'};color:${z === N ? '#FBF8EF' : '#131313'};border:2px solid #131313;padding:9px 15px;font-family:'Archivo',sans-serif;font-weight:700;font-size:14px;cursor:pointer;">${z}</button>`).join('')}</div>`;
    const card = this.querySelector('[data-set-card]');
    card.style.background = cur.color; card.style.color = cur.ink;
    card.innerHTML = `<h3 style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:clamp(24px,3vw,34px);line-height:1;margin:0 0 8px;">${cur.name}</h3>
      <p style="margin:0 0 16px;font-size:14.5px;line-height:1.5;">${cur.desc}</p>${sizeChips}
      <div style="background:#131313;color:#F2EFE4;border:3px solid #131313;padding:16px;">
        <div style="display:flex;align-items:baseline;justify-content:space-between;gap:10px;">
          <span style="font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:.14em;color:#9A968A;">${sizeLabel.toUpperCase()}</span>
          <span style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:30px;">${estTxt}</span>
        </div>
        <div style="font-family:'IBM Plex Mono',monospace;font-size:9.5px;letter-spacing:.08em;color:#8F8B7E;margin-top:6px;line-height:1.5;">ESTIMATED TOTAL · REQUEST A CLASSROOM QUOTE</div>
        <div style="display:flex;flex-wrap:wrap;gap:8px;margin-top:14px;">
          <button data-lance-inquiry data-inq-title="Classroom quote" data-inq-ctx="${cur.name}||${sizeLabel}||Estimated ${estTxt}" data-inq-note="Request tool sizes, quantities and a written quote." style="background:${cur.color};color:${cur.ink};border:2px solid ${cur.color};padding:12px 16px;font-family:'Archivo',sans-serif;font-weight:700;font-size:14px;cursor:pointer;">Request group pricing</button>
        </div>
      </div>`;
    card.querySelectorAll('[data-size]').forEach((b) => b.addEventListener('click', () => { this.classSize = Number(b.dataset.size); this.renderSets(); }));
    this.querySelector('[data-set-components]').innerHTML = comps.map((c) => `
      <article style="display:flex;align-items:center;gap:14px;background:#FBF8EF;border:2px solid #131313;padding:11px 14px;">
        <img src="${c.img}" loading="lazy" decoding="async" alt="${c.name}" style="width:64px;height:48px;object-fit:contain;flex:none;background:#FFFFFF;border:1px solid #E2DDCB;">
        <div style="flex:1;min-width:0;">
          <div style="font-family:'Archivo',sans-serif;font-weight:700;font-size:14.5px;line-height:1.2;"><a href="${c.url}" style="color:#131313;text-decoration:none;">${c.name}</a></div>
          <div style="font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:.06em;color:#6B675C;margin-top:3px;">${c.ea} EACH · ${c.per.toUpperCase()}</div>
          ${c.warn ? '<div style="display:inline-block;background:#B33500;color:#FBF8EF;font-family:\'IBM Plex Mono\',monospace;font-size:9px;letter-spacing:.1em;padding:3px 7px;margin-top:5px;">UNAVAILABLE — SUBSTITUTED AT QUOTE</div>' : ''}
        </div>
        <div style="font-family:'Bricolage Grotesque',sans-serif;font-weight:800;font-size:20px;flex:none;">×${c.qty}</div>
      </article>`).join('');
  }
}
customElements.define('lance-teachers', LanceTeachers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lance-wall"]) return;
  try {
    
class LanceWall extends HTMLElement {
  connectedCallback() {
    const wall = this.querySelector('[data-wall-view]');
    const cmp = this.querySelector('[data-compare-view]');
    this.querySelectorAll('[data-mode]').forEach((b) => b.addEventListener('click', () => {
      const isWall = b.dataset.mode === 'wall';
      wall.hidden = !isWall; cmp.hidden = isWall;
      this.querySelectorAll('[data-mode]').forEach((x) => x.classList.toggle('is-active', x === b));
    }));
    this.querySelectorAll('[data-unit-filter]').forEach((b) => b.addEventListener('click', () => {
      const u = b.dataset.unitFilter;
      this.querySelectorAll('[data-unit-filter]').forEach((x) => x.classList.toggle('is-active', x === b));
      this.querySelectorAll('[data-unit]').forEach((el) => {
        const units = el.dataset.unit;
        const matches = u === 'all' || units === u || (u !== 'both' && (units === 'both' || units === 'choices'));
        el.classList.toggle('is-dim', !matches);
      });
    }));
    this.querySelectorAll('[data-fam-jump]').forEach((b) => b.addEventListener('click', () => {
      const el = document.getElementById('zone-' + b.dataset.famJump);
      if (el) window.scrollTo({ top: el.offsetTop - 128, behavior: 'smooth' });
    }));
    const keys = ['straight-edge-rulers','t-squares','l-squares','curves','triangles','specialty-rulers','black-anodized-rulers'];
    window.addEventListener('scroll', () => {
      let cur = keys[0];
      keys.forEach((k) => { const el = document.getElementById('zone-' + k); if (el && el.getBoundingClientRect().top < 210) cur = k; });
      this.querySelectorAll('[data-fam-jump]').forEach((b) => b.classList.toggle('is-active', b.dataset.famJump === cur));
    }, { passive: true });
  }
}
customElements.define('lance-wall', LanceWall);

  } catch(e) { console.error(e); }
})();
})();
